import { apiClient } from "../../lib/api";

export class AccountGateway {
  async fetchPlan(): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/plan`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async updatePlan(req: any): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/plan`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async updateProject(req: any): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/user/current`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async fetchProfile(): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/vendor`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async editProfile(req: any): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/vendor`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async fetchMember(): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/members`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async addMember(req: any): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/members`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async editMember(req: any): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/member/user`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async selfEditMember(req: any): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/user`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async deleteMember(req: any): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/members`;
    const res = await apiClient.remove({ url: url, body: req });
    return res as any;
  }

  async resetMfa(req: any): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/member/mfa/cancel`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async fetchInvoice(): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/vendor/receipt`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async requestExpertRole(req: any): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/vendor/role/expert`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async rejectRoleRequest(req: any): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/vendor/role/reject`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async acceptInsVendor(): Promise<any> {
    const url = `${process.env.REACT_APP_XCAUSAL_SERVICE_URL}/api/vw/vendor/inspection`;
    const res = await apiClient.post({ url: url });
    return res as any;
  }
}
